import React from 'react'
import { Text } from 'components/Text'
import { Dropdown, DropdownContext } from 'components/Dropdown'
import { Layout } from 'components/Layout'
import { Icon } from 'components/Icon'
import type { RowsPerPageProps } from './TablePagination.types'
import type { ButtonProps } from 'components/Button'
import { NoPaddingButton } from './TablePagination.styles'
import { Popover } from 'components/Popover'

const TriggerButton = (props: Omit<ButtonProps, 'scale' | 'variant'>) => {
  const { toggle } = React.useContext(DropdownContext)

  return (
    <Popover.Reference>
      <NoPaddingButton data-testid="rows-per-page-button" onClick={toggle} {...props}>
        <Icon name="caret-down" size={16} color="neutral-darker" />
      </NoPaddingButton>
    </Popover.Reference>
  )
}

function RowsPerPage({
  page,
  rowsPerPage,
  onRowsPerPageChange,
  labelRowsPerPage,
  count,
  rowsPerPageOptions,
  disabled = false,
  position = 'bottom',
  align = 'start',
}: RowsPerPageProps): JSX.Element {
  const getItemsRange = () => {
    if (!count) {
      return 0
    }

    const from = page * rowsPerPage + 1
    let to = (page + 1) * rowsPerPage

    if (to > count) {
      to = count
    }

    return `${from}-${to}`
  }

  return (
    <Layout.Group space="s" align="center">
      <Text variant="caption" color={disabled ? 'color-neutral' : 'color-neutral-dark'}>
        {labelRowsPerPage}
      </Text>
      <Text variant="body" color={disabled ? 'color-neutral' : 'color-neutral-dark'}>
        <Text variant="body-bold" color={disabled ? 'color-neutral' : 'color-neutral-dark'}>
          {getItemsRange()}
        </Text>{' '}
        of{' '}
        <Text variant="body-bold" color={disabled ? 'color-neutral' : 'color-neutral-dark'}>
          {count}
        </Text>
      </Text>
      <Dropdown position={position} align={align}>
        <TriggerButton disabled={disabled} />
        <Dropdown.Menu>
          {rowsPerPageOptions.map((option) => (
            <Dropdown.Item
              key={option}
              onClick={() => onRowsPerPageChange(option)}
              trailing={option === rowsPerPage && <Icon name="check" size={20} color="accent" />}
            >
              {option} per page
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </Layout.Group>
  )
}

export default RowsPerPage
